<template>
  <ul class="unstyled-list">
    <li v-for="(bot, index) in botones" :key="index">
      <button :id="'bot-slide-'+index" :aria-label="bot.name + ' ' + (bot.visto?'Visto':'No visto')" @click="botClick(index, bot)" class="bot-slide animated flipInY" :class="(botNumber === (index+1)?'slide-active':'') + ' ' + ('dura_'+index)">
        <div class="bot-slider">
          <div class="botnum">
            {{index+1}}
          </div>
        </div>
        <span>{{bot.name}}</span>
        <div class="bot-check">
          <image-app v-if="bot.visto" class="animated bounceIn" :imaSize="20" imaSrc="logos-icons/ok-bullet" imaAlt=""></image-app>
        </div>
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    botsNames: {
      type: Array,
      requiere: true
    }
  },
  data() {
    return {
      botNumber: 0,
      botones: this.botsNames
    };
  },
  methods: {
    botClick(event, arr) {
      arr.visto = true;
      this.botNumber = event + 1;
      this.$emit("currentBot", event + 1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables";
@import "../../sass/helpers/mixins";
.bot-slide,
.slide-active {
  width: 250px;
  padding: 5px 45px;
  min-height: 50px;
  font-size: 1.2rem;
  line-height: 1.2rem;
  text-align: right;
  border-radius: 25px;
  -moz-box-shadow: inset 0 0 10px #000000;
  -webkit-box-shadow: inset 0 0 10px #000000;
  box-shadow: inset 0 0 10px #000000;
  position: relative;
  color: #444;
  margin: 7px auto;
  background-color: white;
  &:hover {
    background-color: lighten($secondary-red, 40);
  }
  .bot-slider {
    background-color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    -moz-box-shadow: 0 0 10px #777;
    -webkit-box-shadow: 0 0 10px #777;
    box-shadow: 0 0 10px #777;
    position: absolute;
    left: 6px;
    top: 10px;
    font-weight: bold;
    display: table;
    text-align: center;
    @include transit(all, 0.5s);
    background-color: $secondary-red;
    .botnum {
      color: white;
      font-size: 23px;
      display: table-cell;
      vertical-align: middle;
    }
  }
  .bot-check{
    position: absolute;
    right: -10px;
    top: 0;
  }
}
.slide-active {
  background-color: $secondary-red;
  color: white;
  text-align: left;
  .bot-slider {
    background-color: white;
    left: 215px;
    .botnum {
      color: $secondary-red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// tabsButtonsSlideList.vue?a2b64fe4